import { isNotEmptyTrimmedStringValidator, isEmailValidator } from '@currency-one/validators'
import { promiseWrapper } from 'utils/promise'
import { isJson } from 'utils/json'
import { FormPayload, payloadToSend } from './notification-slider'
import { pushDataLayer } from 'utils/data-layer-push'
import initCaptcha, { getRecaptchaResponse, loadRecaptcha, recaptachaReset } from 'utils/captcha'

declare const USER_BASE_URL_WT: string

type ErrorAttribute = 'err' | 'mail' | 'captcha'

const hideErrors = (): void => {
  const $errorFields = document.querySelectorAll<HTMLSpanElement>('[data-error-field]')
  const $errorHolder = document.querySelector<HTMLSpanElement>("[data-error-field='err']")
  const $agreementField = document.querySelector<HTMLDivElement>('.general-form-style__checkbox-label')

  if ($errorFields && $errorFields) {
    $agreementField.style.backgroundColor = '#fff'
    $errorHolder.hidden = true
    $errorHolder.hidden = true

    $errorFields.forEach((field) => {
      if (field.hidden === false) {
        field.hidden = true
      }
    })
  }
}

const showErrorMessage = (attribute: ErrorAttribute): void => {
  const $errorField = document.querySelector<HTMLSpanElement>(`[data-error-field="${attribute}"]`)
  const $agreementField = document.querySelector<HTMLDivElement>('.general-form-style__checkbox-label')
  if ($errorField) {
    $errorField.hidden = false
  }
  if (attribute === 'err' && $agreementField) {
    $agreementField.style.backgroundColor = '#ffdee1'
  }
}

const changeView = (isShown: boolean): void => {
  const $popupForm = document.querySelector<HTMLDivElement>('[data-form-element]')
  const $popupSecondViewElement = document.querySelector<HTMLDivElement>('[data-second-view]')
  if ($popupForm && $popupSecondViewElement) {
    $popupForm.hidden = isShown
    $popupSecondViewElement.hidden = !isShown
  }
}

const agreementValidation = (): boolean => {
  const inputCheckbox = document.querySelector<HTMLInputElement>('[data-checkbox-field]').checked
  if (!inputCheckbox) {
    showErrorMessage('err')
    return false
  }
  return true
}

const mailValidation = (): boolean => {
  const userMail = document.querySelector<HTMLInputElement>('[data-email-field]').value
  const $mailPopupPlaceholder = document.querySelector<HTMLSpanElement>('[data-popup-email]')

  if (!isNotEmptyTrimmedStringValidator(userMail) || !isEmailValidator(userMail)) {
    showErrorMessage('mail')
    return false
  }

  payloadToSend.email = userMail
  $mailPopupPlaceholder.textContent = userMail
  return true
}

const recaptchaValidation = (): boolean => {
  if (getRecaptchaResponse().length === 0) {
    showErrorMessage('captcha')
    return false
  }

  return true
}

const handleError = (error: XMLHttpRequest): void => {
  const $errorHolder = document.querySelector<HTMLSpanElement>("[data-error-field='error-holder']")

  if ($errorHolder) {
    $errorHolder.hidden = false
    if (isJson(error.response)) {
      const resp = JSON.parse(error.response)
      const [prop] = Object.keys(resp.errors || {})
      switch (prop) {
        case 'my_price':
          $errorHolder.textContent =
            payloadToSend.language === 'pl'
              ? 'Kurs musi być liczbą mniejszą od 99,9999'
              : 'The rate must be a number less than 99,9999'
          break
        case 'email':
          if (resp.errors.email.msg === 'ALERT_ALREADY_EXISTS') {
            $errorHolder.textContent =
              payloadToSend.language === 'pl'
                ? 'Alert kursowy dla podanego kursu już istnieje'
                : 'A rate alert already exists for the specified rate'
          } else {
            $errorHolder.textContent =
              payloadToSend.language === 'pl'
                ? 'Nie możesz zapisać się na większą ilość alertów. (max. 10)'
                : 'You cannot sign up for more alerts. (max. 10)'
          }
          break
        default:
          $errorHolder.textContent =
            payloadToSend.language === 'pl'
              ? 'Coś poszło nie tak, spróbuj za chwilę.'
              : 'Something went wrong, please try again later.'
          break
      }
    } else {
      $errorHolder.textContent =
        payloadToSend.language === 'pl'
          ? 'Coś poszło nie tak, spróbuj za chwilę.'
          : 'Something went wrong, please try again later.'
    }
  }
}

const sendData = (payload: FormPayload): Promise<void> => {
  return promiseWrapper<void, FormPayload>(
    `${USER_BASE_URL_WT}/api/public/exchange-rates-notify/subscribe/`,
    'POST',
    payload,
  )
}

const notificationService = (): void => {
  hideErrors()
  if (mailValidation() && agreementValidation() && recaptchaValidation()) {
    sendData(payloadToSend)
      .then(() => {
        pushDataLayer('form_submitted', { form_name: 'Zapis na alert walutowy' })
        changeView(true)
        recaptachaReset()
      })
      .catch(handleError)
  }
}

const clearInputsAndViews = (): void => {
  const $mailInput = document.querySelector<HTMLInputElement>('[data-email-field]')
  const $checkboxInput = document.querySelector<HTMLInputElement>('[data-checkbox-field]')

  recaptachaReset()
  hideErrors()
  changeView(false)

  if ($mailInput) {
    $mailInput.value = ''
  }

  if ($checkboxInput) {
    $checkboxInput.checked ? ($checkboxInput.checked = false) : ''
  }
}

const initButtonsService = (): void => {
  const $notificationPopup = document.querySelector<HTMLDivElement>('[data-notification-popup]')
  const $openPopupButton = document.querySelector<HTMLDivElement>('[data-open-popup]')
  const $exitPopupButton = document.querySelector<HTMLDivElement>('[data-exit-popup]')
  const $submitFormButton = document.querySelector<HTMLDivElement>('[data-submit-form]')
  const $closeEndViewButton = document.querySelector<HTMLDivElement>('[data-close-popup]')

  if ($openPopupButton) {
    $openPopupButton.addEventListener('click', () => {
      loadRecaptcha()
      $notificationPopup.hidden = false
    })
  }

  if ($exitPopupButton) {
    $exitPopupButton.addEventListener('click', () => {
      $notificationPopup.hidden = true
      clearInputsAndViews()
    })
  }

  if ($submitFormButton) {
    $submitFormButton.addEventListener('click', () => {
      notificationService()
    })
  }

  if ($closeEndViewButton) {
    $closeEndViewButton.addEventListener('click', () => {
      $notificationPopup.hidden = true
      clearInputsAndViews()
    })
  }
}

export const initExitPopup = (): void => {
  const $notificationPopup = document.querySelector<HTMLDivElement>('[data-notification-popup]')
  if ($notificationPopup) {
    initCaptcha()
    initButtonsService()
  }
}
